import {
  ADD_EXCEL_ACTIVITY_NOTE_FAILURE,
  ADD_EXCEL_ACTIVITY_NOTE_REQUEST,
  ADD_EXCEL_ACTIVITY_NOTE_SUCCESS,
  ADD_ORGANISATION_FAILURE,
  ADD_ORGANISATION_REQUEST,
  ADD_ORGANISATION_SUCCESS,
  BULK_UPDATE_EXCEL_TRANSACTIONS_FAILURE,
  BULK_UPDATE_EXCEL_TRANSACTIONS_REQUEST,
  BULK_UPDATE_EXCEL_TRANSACTIONS_SUCCESS,
  CLEAR_PENDING_NAVIGATE_AFTER_CREATE,
  CLEAR_UPLOAD_EXCEL_RESULT,
  CLEAR_UPLOAD_TRANSACTIONS_TEMP,
  CONNECT_CIN7_ENTITY_FAILURE,
  CONNECT_CIN7_ENTITY_REQUEST,
  CONNECT_CIN7_ENTITY_SUCCESS,
  COMPLETE_SCAN_STEPS_FAILURE,
  COMPLETE_SCAN_STEPS_REQUEST,
  COMPLETE_SCAN_STEPS_SUCCESS,
  HMRC_FRAUD_HEADER_TEST_FAILURE,
  HMRC_FRAUD_HEADER_TEST_REQUEST,
  HMRC_FRAUD_HEADER_TEST_SUCCESS,
  CREATE_ENTITY_GROUP_FAILURE,
  CREATE_ENTITY_GROUP_REQUEST,
  CREATE_ENTITY_GROUP_SUCCESS,
  DELETE_ENTITY_GROUP_FAILURE,
  DELETE_ENTITY_GROUP_REQUEST,
  DELETE_ENTITY_GROUP_SUCCESS,
  DELETE_EXCEL_TRANSACTIONS_FILE_FAILURE,
  DELETE_EXCEL_TRANSACTIONS_FILE_REQUEST,
  DELETE_EXCEL_TRANSACTIONS_FILE_SUCCESS,
  DELETE_ORGANISATION_ATTACHMENT_FAILURE,
  DELETE_ORGANISATION_ATTACHMENT_REQUEST,
  DELETE_ORGANISATION_ATTACHMENT_SUCCESS,
  DISCONNECT_FOLDER,
  DISCONNECT_ORGANISATION_FAILURE,
  DISCONNECT_ORGANISATION_REQUEST,
  DISCONNECT_ORGANISATION_SUCCESS,
  EDIT_ORGANISATION_FAILURE,
  EDIT_ORGANISATION_REQUEST,
  EDIT_ORGANISATION_SUCCESS,
  FETCH_ACCOUNTS_FAILURE,
  FETCH_ACCOUNTS_REQUEST,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ADD_URL_FAILURE,
  FETCH_ADD_URL_REQUEST,
  FETCH_ADD_URL_SUCCESS,
  FETCH_ALL_EXCEL_TRANSACTIONS_FAILURE,
  FETCH_ALL_EXCEL_TRANSACTIONS_REQUEST,
  FETCH_ALL_EXCEL_TRANSACTIONS_SUCCESS,
  FETCH_EXCEL_ACTIVITY_LOGS_FAILURE,
  FETCH_EXCEL_ACTIVITY_LOGS_REQUEST,
  FETCH_EXCEL_ACTIVITY_LOGS_SUCCESS,
  FETCH_EXCEL_FILES_METADATA_FAILURE,
  FETCH_EXCEL_FILES_METADATA_REQUEST,
  FETCH_EXCEL_FILES_METADATA_SUCCESS,
  CLEAR_RECEIPT_UPLOAD_STATUS,
  FETCH_LAST_RECEIPT_UPLOAD_STATUS_FAILURE,
  FETCH_LAST_RECEIPT_UPLOAD_STATUS_REQUEST,
  FETCH_LAST_RECEIPT_UPLOAD_STATUS_SUCCESS,
  FETCH_ORGANISATION_CONTACTS_FAILURE,
  FETCH_ORGANISATION_CONTACTS_REQUEST,
  FETCH_ORGANISATION_CONTACTS_SUCCESS,
  FETCH_ORGANISATIONS_FAILURE,
  FETCH_ORGANISATIONS_REQUEST,
  FETCH_ORGANISATIONS_SUCCESS,
  FETCH_TRACKING_CATEGORIES_FAILURE,
  FETCH_TRACKING_CATEGORIES_REQUEST,
  FETCH_TRACKING_CATEGORIES_SUCCESS,
  FETCH_TRANSACTION_ITEMS_FAILURE,
  FETCH_TRANSACTION_ITEMS_REQUEST,
  FETCH_TRANSACTION_ITEMS_SUCCESS,
  FETCH_UPLOADED_FILE_TRANSACTIONS_FAILURE,
  FETCH_UPLOADED_FILE_TRANSACTIONS_REQUEST,
  FETCH_UPLOADED_FILE_TRANSACTIONS_SUCCESS,
  GET_FILES_UPLOAD_HISTORY,
  REACTIVATE_ORGANISATION_FAILURE,
  REACTIVATE_ORGANISATION_REQUEST,
  REACTIVATE_ORGANISATION_SUCCESS,
  RESET_ORGANISATION_DATA,
  SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_FAILURE,
  SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_REQUEST,
  SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_SUCCESS,
  CLEAR_DRAWER_TRANSACTION_ID_MAP,
  SET_DRIVE_SCANNER_STATUS,
  SET_FILES_UPLOAD_HISTORY,
  SET_GOOGLE_ACCESS_TOKEN,
  SET_SCAN_EMAIL,
  SET_TRANSACTIONS_REVIEWED_FAILURE,
  SET_TRANSACTIONS_REVIEWED_REQUEST,
  SET_TRANSACTIONS_REVIEWED_SUCCESS,
  SET_UPLOAD_TRANSACTIONS_TEMP,
  UPDATE_ENTITY_GROUP_FAILURE,
  UPDATE_ENTITY_GROUP_REQUEST,
  UPDATE_ENTITY_GROUP_SUCCESS,
  UPDATE_ENTITY_MEMBERS,
  UPDATE_ENTITY_MEMBERS_BULK,
  UPDATE_EXCEL_TRANSACTION_FAILURE,
  UPDATE_EXCEL_TRANSACTION_REQUEST,
  UPDATE_EXCEL_TRANSACTION_SUCCESS,
  UPDATE_ORGANISATION_CHART_OF_ACCOUNTS,
  UPDATE_ORGANISATION_DATA,
  UPDATE_ORGANISATION_TAX_RATES,
  UPDATE_ORGANISATION_TOTAL_TAX_BALANCE,
  UPDATE_RECEIPT_FILE_STATUS,
  UPDATE_SUBMISSION_LOG,
  UPLOAD_EXCEL_TRANSACTIONS_FAILURE,
  UPLOAD_EXCEL_TRANSACTIONS_REQUEST,
  UPLOAD_EXCEL_TRANSACTIONS_SUCCESS,
  UPLOAD_ORGANISATION_ATTACHMENT_FAILURE,
  UPLOAD_ORGANISATION_ATTACHMENT_REQUEST,
  UPLOAD_ORGANISATION_ATTACHMENT_SUCCESS,
  UPLOAD_RECEIPT_FAILURE,
  UPLOAD_RECEIPT_REQUEST,
  UPLOAD_RECEIPT_SUCCESS,
  UPLOAD_RECEIPT_TO_PROVIDER_FAILURE,
  UPLOAD_RECEIPT_TO_PROVIDER_REQUEST,
  UPLOAD_RECEIPT_TO_PROVIDER_SUCCESS,
  FETCH_RECEIPT_STATISTICS_ALL_REQUEST,
  FETCH_RECEIPT_STATISTICS_ALL_SUCCESS,
  FETCH_RECEIPT_STATISTICS_ALL_FAILURE,
  FETCH_RECEIPT_STATISTICS_ENTITY_REQUEST,
  FETCH_RECEIPT_STATISTICS_ENTITY_SUCCESS,
  FETCH_RECEIPT_STATISTICS_ENTITY_FAILURE,
  INVALIDATE_RECEIPT_STATISTICS,
} from '../constants';
import {
  AddOrganisationRequestAction,
  CreateEntityGroupRequestAction,
  DeleteEntityGroupRequestAction,
  FetchAccountsSuccessAction,
  FetchAllExcelTransactionsSuccessAction,
  CompleteScanStepsSuccessAction,
  HmrcFraudHeaderTestSuccessAction,
  FetchExcelActivityLogsSuccessAction,
  FetchExcelFilesMetadataSuccessAction,
  FetchLastReceiptUploadStatusSuccessAction,
  FetchOrganisationContactsSuccessAction,
  FetchOrganisationsSuccessAction,
  FetchTrackingCategoriesSuccessAction,
  FetchTransactionItemsSuccessAction,
  FetchUploadedFileTransactionsSuccessAction,
  OrganisationAction,
  OrganisationState,
  SaveExcelDrawerTransactionsBatchRequestAction,
  SaveExcelDrawerTransactionsBatchSuccessAction,
  SetUploadTransactionsTempAction,
  UpdateEntityGroupRequestAction,
  UpdateEntityMembersAction,
  UpdateEntityMembersBulkAction,
  UpdateExcelTransactionRequestAction,
  UpdateOrganisationChartOfAccountsAction,
  UpdateOrganisationDataAction,
  UpdateOrganisationTaxRatesAction,
  UpdateOrganisationTotalTaxBalanceAction,
  UpdateSubmissionLogAction,
  UploadExcelTransactionsFailureAction,
  UploadExcelTransactionsSuccessAction,
  UploadOrganisationAttachmentSuccessAction,
  UploadReceiptSuccessAction,
  FetchReceiptStatisticsAllSuccessAction,
  FetchReceiptStatisticsEntitySuccessAction,
} from '../types';
import {
  handleAddOrganisationFailure,
  handleAddOrganisationRequest,
  handleClearPendingNavigateAfterCreate,
  handleResetOrganisationData,
  handleSetUploadTransactionsTemp,
  handleUpdateOrganisationChartOfAccounts,
  handleUpdateOrganisationData,
} from './crudHandlers';
import {
  handleDisconnectFolder,
  handleGetFilesUploadHistory,
  handleReceiptFileStatus,
  handleSetDriveScannerStatus,
  handleSetFilesUploadHistory,
  handleSetGoogleAccessToken,
  handleSetScanEmail,
} from './driveHandlers';
import {
  handleFetchAllExcelTransactionsFailure,
  handleFetchAllExcelTransactionsRequest,
  handleFetchAllExcelTransactionsSuccess,
  handleFetchExcelActivityLogsSuccess,
  handleFetchExcelFilesMetadataSuccess,
  handleFetchTrackingCategoriesSuccess,
  handleFetchTransactionItemsSuccess,
  handleFetchUploadedFileTransactionsSuccess,
  handleUploadExcelTransactionsFailure,
  handleUploadExcelTransactionsRequest,
  handleUploadExcelTransactionsSuccess,
  applyOptimisticTransactionUpdate,
  applyOptimisticTransactionBatchUpdate,
  restoreTransactionsFromRollback,
} from './excelHandlers';
import { appendDrawerTransactionIdHops } from '../drawerTransactionIdMap';
import { initialState } from './initialState';
import {
  handleFetchAccountsFailure,
  handleFetchAccountsRequest,
  handleFetchAccountsSuccess,
  handleFetchOrganisationContactsFailure,
  handleFetchOrganisationContactsRequest,
  handleFetchOrganisationContactsSuccess,
  handleFetchOrganisationsSuccess,
  handleCompleteScanStepsSuccess,
  handleUpdateEntityMembers,
  handleUpdateEntityMembersBulk,
  handleUpdateOrganisationTaxRates,
  handleUpdateOrganisationTotalTaxBalance,
  handleUpdateSubmissionLog,
  handleUploadOrganisationAttachmentSuccess,
} from './organisationHandlers';
import {
  handleFailure,
  handleRequest,
  handleSuccess,
  handleUploadReceiptFailure,
  handleUploadReceiptRequest,
} from './sharedHandlers';

export const organisationReducer = (
  state = initialState,
  action: OrganisationAction
): OrganisationState => {
  switch (action.type) {
    case FETCH_ORGANISATIONS_REQUEST:
    case EDIT_ORGANISATION_REQUEST:
    case DISCONNECT_ORGANISATION_REQUEST:
    case REACTIVATE_ORGANISATION_REQUEST:
    case FETCH_ADD_URL_REQUEST:
    case CONNECT_CIN7_ENTITY_REQUEST:
    case UPLOAD_ORGANISATION_ATTACHMENT_REQUEST:
    case DELETE_ORGANISATION_ATTACHMENT_REQUEST:
    case ADD_ORGANISATION_REQUEST:
    case CREATE_ENTITY_GROUP_REQUEST:
    case UPDATE_ENTITY_GROUP_REQUEST:
    case DELETE_ENTITY_GROUP_REQUEST:
      return handleAddOrganisationRequest(
        state,
        action as
          | AddOrganisationRequestAction
          | CreateEntityGroupRequestAction
          | DeleteEntityGroupRequestAction
          | UpdateEntityGroupRequestAction
      );
    // Background metadata fetch — must not flip page-level loading
    // (Entities would flash skeleton after the list already painted).
    case FETCH_EXCEL_FILES_METADATA_REQUEST:
    case FETCH_TRACKING_CATEGORIES_REQUEST:
      return state;
    case DELETE_EXCEL_TRANSACTIONS_FILE_REQUEST:
    case FETCH_UPLOADED_FILE_TRANSACTIONS_REQUEST:
    case FETCH_LAST_RECEIPT_UPLOAD_STATUS_REQUEST:
    case SET_TRANSACTIONS_REVIEWED_REQUEST:
    case BULK_UPDATE_EXCEL_TRANSACTIONS_REQUEST:
    case FETCH_EXCEL_ACTIVITY_LOGS_REQUEST:
    case FETCH_TRANSACTION_ITEMS_REQUEST:
    case ADD_EXCEL_ACTIVITY_NOTE_REQUEST:
    case UPLOAD_RECEIPT_TO_PROVIDER_REQUEST:
    case COMPLETE_SCAN_STEPS_REQUEST:
    case HMRC_FRAUD_HEADER_TEST_REQUEST:
      return handleRequest(state);
    case UPLOAD_EXCEL_TRANSACTIONS_REQUEST:
      return handleUploadExcelTransactionsRequest(state);
    case FETCH_ACCOUNTS_REQUEST:
      return handleFetchAccountsRequest(state);
    case FETCH_ORGANISATION_CONTACTS_REQUEST:
      return handleFetchOrganisationContactsRequest(state);
    case UPLOAD_RECEIPT_REQUEST:
      return handleUploadReceiptRequest(state);
    case FETCH_ORGANISATIONS_SUCCESS:
      return handleFetchOrganisationsSuccess(
        state,
        action as FetchOrganisationsSuccessAction
      );
    case FETCH_ACCOUNTS_SUCCESS:
      return handleFetchAccountsSuccess(
        state,
        action as FetchAccountsSuccessAction
      );
    case FETCH_ORGANISATION_CONTACTS_SUCCESS:
      return handleFetchOrganisationContactsSuccess(
        state,
        action as FetchOrganisationContactsSuccessAction
      );
    case UPDATE_EXCEL_TRANSACTION_REQUEST:
      return applyOptimisticTransactionUpdate(
        state,
        (action as UpdateExcelTransactionRequestAction).payload.transactionUuid,
        (action as UpdateExcelTransactionRequestAction).payload.body
      );
    case UPDATE_EXCEL_TRANSACTION_SUCCESS:
      return {
        ...state,
        pendingExcelTransactionRollback: null,
      };
    case UPDATE_EXCEL_TRANSACTION_FAILURE:
      return restoreTransactionsFromRollback(
        state,
        state.pendingExcelTransactionRollback
      );
    case SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_REQUEST: {
      const batchAction =
        action as SaveExcelDrawerTransactionsBatchRequestAction;
      return {
        ...applyOptimisticTransactionBatchUpdate(
          state,
          batchAction.payload.items
        ),
        excelDrawerTransactionsBatchSaving: true,
      };
    }
    case SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_SUCCESS: {
      const successAction = action as SaveExcelDrawerTransactionsBatchSuccessAction;
      const idHops = successAction.payload?.idHops ?? [];
      return {
        ...state,
        excelDrawerTransactionsBatchSaving: false,
        pendingExcelTransactionRollback: null,
        bulkUpdateExcelTransactionsSuccessCount:
          (state.bulkUpdateExcelTransactionsSuccessCount ?? 0) + 1,
        drawerTransactionIdMap:
          idHops.length > 0
            ? appendDrawerTransactionIdHops(
                state.drawerTransactionIdMap,
                idHops
              )
            : state.drawerTransactionIdMap ?? {},
      };
    }
    case SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_FAILURE:
      return {
        ...restoreTransactionsFromRollback(
          state,
          state.pendingExcelTransactionRollback
        ),
        excelDrawerTransactionsBatchSaving: false,
      };
    case CLEAR_DRAWER_TRANSACTION_ID_MAP:
      return {
        ...state,
        drawerTransactionIdMap: {},
      };
    case FETCH_ALL_EXCEL_TRANSACTIONS_REQUEST:
      return handleFetchAllExcelTransactionsRequest(state);
    case FETCH_ADD_URL_SUCCESS:
    case CONNECT_CIN7_ENTITY_SUCCESS:
    case DISCONNECT_ORGANISATION_SUCCESS:
    case REACTIVATE_ORGANISATION_SUCCESS:
    case EDIT_ORGANISATION_SUCCESS:
    case DELETE_ORGANISATION_ATTACHMENT_SUCCESS:
    case DELETE_EXCEL_TRANSACTIONS_FILE_SUCCESS:
    case ADD_ORGANISATION_SUCCESS:
    case CREATE_ENTITY_GROUP_SUCCESS:
    case UPDATE_ENTITY_GROUP_SUCCESS:
    case DELETE_ENTITY_GROUP_SUCCESS:
    case ADD_EXCEL_ACTIVITY_NOTE_SUCCESS:
      return handleSuccess(state);
    case COMPLETE_SCAN_STEPS_SUCCESS:
      return handleCompleteScanStepsSuccess(
        state,
        action as CompleteScanStepsSuccessAction
      );
    case HMRC_FRAUD_HEADER_TEST_SUCCESS: {
      const { connectionId, result } = (
        action as HmrcFraudHeaderTestSuccessAction
      ).payload;
      return {
        ...handleSuccess(state),
        hmrcFraudHeaderTestResult: { connectionId, result },
      };
    }
    case UPLOAD_RECEIPT_TO_PROVIDER_SUCCESS:
      return {
        ...handleSuccess(state),
        isPostingToProvider: false,
      };
    case UPLOAD_EXCEL_TRANSACTIONS_SUCCESS:
      return handleUploadExcelTransactionsSuccess(
        state,
        action as UploadExcelTransactionsSuccessAction
      );
    case FETCH_UPLOADED_FILE_TRANSACTIONS_SUCCESS:
      return handleFetchUploadedFileTransactionsSuccess(
        state,
        action as FetchUploadedFileTransactionsSuccessAction
      );
    case FETCH_ALL_EXCEL_TRANSACTIONS_SUCCESS:
      return handleFetchAllExcelTransactionsSuccess(
        state,
        action as FetchAllExcelTransactionsSuccessAction
      );
    case UPLOAD_ORGANISATION_ATTACHMENT_SUCCESS:
      return handleUploadOrganisationAttachmentSuccess(
        state,
        action as UploadOrganisationAttachmentSuccessAction
      );
    case FETCH_EXCEL_FILES_METADATA_SUCCESS:
      return handleFetchExcelFilesMetadataSuccess(
        state,
        action as FetchExcelFilesMetadataSuccessAction
      );
    case FETCH_EXCEL_ACTIVITY_LOGS_SUCCESS:
      return handleFetchExcelActivityLogsSuccess(
        state,
        action as FetchExcelActivityLogsSuccessAction
      );
    case FETCH_TRACKING_CATEGORIES_SUCCESS:
      return handleFetchTrackingCategoriesSuccess(
        state,
        action as FetchTrackingCategoriesSuccessAction
      );
    case FETCH_TRANSACTION_ITEMS_SUCCESS:
      return handleFetchTransactionItemsSuccess(
        state,
        action as FetchTransactionItemsSuccessAction
      );
    case UPLOAD_RECEIPT_SUCCESS:
      return {
        ...state,
        loading: false,
        lastUploadedReceiptsBatchId:
          (action as UploadReceiptSuccessAction).payload?.batchId ?? null,
      };
    case FETCH_LAST_RECEIPT_UPLOAD_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        lastReceiptUploadStatus: (
          action as FetchLastReceiptUploadStatusSuccessAction
        ).payload?.status,
      };
    case CLEAR_RECEIPT_UPLOAD_STATUS:
      return {
        ...state,
        lastReceiptUploadStatus: undefined,
        lastUploadedReceiptsBatchId: null,
      };
    case SET_TRANSACTIONS_REVIEWED_SUCCESS:
      return {
        ...state,
        loading: false,
        bulkUpdateExcelTransactionsSuccessCount:
          (state.bulkUpdateExcelTransactionsSuccessCount ?? 0) + 1,
      };
    case BULK_UPDATE_EXCEL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        bulkUpdateExcelTransactionsSuccessCount:
          (state.bulkUpdateExcelTransactionsSuccessCount ?? 0) + 1,
      };
    case FETCH_ORGANISATIONS_FAILURE:
    case DISCONNECT_ORGANISATION_FAILURE:
    case REACTIVATE_ORGANISATION_FAILURE:
    case FETCH_ADD_URL_FAILURE:
    case CONNECT_CIN7_ENTITY_FAILURE:
    case EDIT_ORGANISATION_FAILURE:
    case UPLOAD_ORGANISATION_ATTACHMENT_FAILURE:
    case DELETE_ORGANISATION_ATTACHMENT_FAILURE:
    case ADD_ORGANISATION_FAILURE:
    case CREATE_ENTITY_GROUP_FAILURE:
    case UPDATE_ENTITY_GROUP_FAILURE:
    case DELETE_ENTITY_GROUP_FAILURE:
      return handleAddOrganisationFailure(state);
    case CLEAR_PENDING_NAVIGATE_AFTER_CREATE:
      return handleClearPendingNavigateAfterCreate(state);
    case FETCH_EXCEL_FILES_METADATA_FAILURE:
    case FETCH_TRACKING_CATEGORIES_FAILURE:
      return state;
    case DELETE_EXCEL_TRANSACTIONS_FILE_FAILURE:
    case FETCH_UPLOADED_FILE_TRANSACTIONS_FAILURE:
    case FETCH_LAST_RECEIPT_UPLOAD_STATUS_FAILURE:
    case SET_TRANSACTIONS_REVIEWED_FAILURE:
    case BULK_UPDATE_EXCEL_TRANSACTIONS_FAILURE:
    case FETCH_EXCEL_ACTIVITY_LOGS_FAILURE:
    case FETCH_TRANSACTION_ITEMS_FAILURE:
    case ADD_EXCEL_ACTIVITY_NOTE_FAILURE:
    case COMPLETE_SCAN_STEPS_FAILURE:
    case HMRC_FRAUD_HEADER_TEST_FAILURE:
      return handleFailure(state);
    case UPLOAD_RECEIPT_TO_PROVIDER_FAILURE:
      return {
        ...handleFailure(state),
        isPostingToProvider: false,
      };
    case FETCH_ALL_EXCEL_TRANSACTIONS_FAILURE:
      return handleFetchAllExcelTransactionsFailure(state);
    case FETCH_ACCOUNTS_FAILURE:
      return handleFetchAccountsFailure(state);
    case FETCH_ORGANISATION_CONTACTS_FAILURE:
      return handleFetchOrganisationContactsFailure(state);
    case UPLOAD_EXCEL_TRANSACTIONS_FAILURE:
      return handleUploadExcelTransactionsFailure(
        state,
        action as UploadExcelTransactionsFailureAction
      );
    case UPLOAD_RECEIPT_FAILURE:
      return handleUploadReceiptFailure(state);
    case UPDATE_ENTITY_MEMBERS:
      return handleUpdateEntityMembers(
        state,
        action as UpdateEntityMembersAction
      );
    case UPDATE_ENTITY_MEMBERS_BULK:
      return handleUpdateEntityMembersBulk(
        state,
        action as UpdateEntityMembersBulkAction
      );
    case UPDATE_SUBMISSION_LOG:
      return handleUpdateSubmissionLog(
        state,
        action as UpdateSubmissionLogAction
      );
    case RESET_ORGANISATION_DATA:
      return handleResetOrganisationData();
    case UPDATE_ORGANISATION_DATA:
      return handleUpdateOrganisationData(
        state,
        action as UpdateOrganisationDataAction
      );
    case UPDATE_ORGANISATION_CHART_OF_ACCOUNTS:
      return handleUpdateOrganisationChartOfAccounts(
        state,
        action as UpdateOrganisationChartOfAccountsAction
      );
    case UPDATE_ORGANISATION_TAX_RATES:
      return handleUpdateOrganisationTaxRates(
        state,
        action as UpdateOrganisationTaxRatesAction
      );
    case UPDATE_ORGANISATION_TOTAL_TAX_BALANCE:
      return handleUpdateOrganisationTotalTaxBalance(
        state,
        action as UpdateOrganisationTotalTaxBalanceAction
      );
    case SET_UPLOAD_TRANSACTIONS_TEMP:
      return handleSetUploadTransactionsTemp(
        state,
        action as SetUploadTransactionsTempAction
      );
    case CLEAR_UPLOAD_TRANSACTIONS_TEMP:
      return {
        ...state,
        uploadTransactionsTemp: undefined,
        uploadExcelTransactionsStatus: null,
        uploadExcelTransactionsValidationData: undefined,
        uploadedFileTransactionsPage: undefined,
      };
    case CLEAR_UPLOAD_EXCEL_RESULT:
      return {
        ...state,
        uploadExcelTransactionsStatus: null,
        uploadExcelTransactionsValidationData: undefined,
        uploadedFileTransactionsPage: undefined,
      };
    case SET_GOOGLE_ACCESS_TOKEN:
      return handleSetGoogleAccessToken(state, action);
    case SET_DRIVE_SCANNER_STATUS:
      return handleSetDriveScannerStatus(state, action);
    case GET_FILES_UPLOAD_HISTORY:
      return handleGetFilesUploadHistory(state, action);
    case SET_FILES_UPLOAD_HISTORY:
      return handleSetFilesUploadHistory(state, action);
    case UPDATE_RECEIPT_FILE_STATUS:
      return handleReceiptFileStatus(state, action);
    case DISCONNECT_FOLDER:
      return handleDisconnectFolder(state, action);
    case SET_SCAN_EMAIL:
      return handleSetScanEmail(state, action);
    case FETCH_RECEIPT_STATISTICS_ALL_REQUEST:
      return {
        ...state,
        receiptStatisticsLoading: true,
      };
    case FETCH_RECEIPT_STATISTICS_ALL_SUCCESS:
      return {
        ...state,
        receiptStatisticsLoading: false,
        receiptStatisticsAll: (action as FetchReceiptStatisticsAllSuccessAction)
          .payload.statistics,
        receiptStatisticsDateRange: (
          action as FetchReceiptStatisticsAllSuccessAction
        ).payload.dateRange,
      };
    case FETCH_RECEIPT_STATISTICS_ALL_FAILURE:
      return {
        ...state,
        receiptStatisticsLoading: false,
      };
    case FETCH_RECEIPT_STATISTICS_ENTITY_REQUEST:
      return {
        ...state,
        receiptStatisticsEntityLoading: true,
      };
    case FETCH_RECEIPT_STATISTICS_ENTITY_SUCCESS: {
      const entityAction = action as FetchReceiptStatisticsEntitySuccessAction;
      return {
        ...state,
        receiptStatisticsEntityLoading: false,
        receiptStatisticsEntityByKey: {
          ...state.receiptStatisticsEntityByKey,
          [entityAction.payload.cacheKey]: entityAction.payload.statistics,
        },
      };
    }
    case FETCH_RECEIPT_STATISTICS_ENTITY_FAILURE:
      return {
        ...state,
        receiptStatisticsEntityLoading: false,
      };
    case INVALIDATE_RECEIPT_STATISTICS:
      return {
        ...state,
        receiptStatisticsAll: undefined,
        receiptStatisticsDateRange: undefined,
        receiptStatisticsEntityByKey: undefined,
      };

    default:
      return state;
  }
};
